import { PageTable, Header } from "/src/layouts/page";
import Tabs from "/src/components/UI/Tabs/Tabs";
import EvaluationForm from "/src/features/supervision/callEvaluation/components/EvaluationForm/EvaluationForm";
import EvaluationStats from "/src/features/supervision/callEvaluation/components/EvaluationStats/EvaluationStats";
import useCallEvaluation from "/src/features/supervision/callEvaluation/hooks/useCallEvaluation";

function CallEvaluationPage() {
    // The notepad draft and the evaluation log live here, above the tabs, so
    // switching to Statistics mid-call never loses what has been typed.
    const evaluation = useCallEvaluation();

    const tabs = [
        { key: "evaluation", label: "Evaluation", icon: "fas fa-clipboard-check", content: <EvaluationForm evaluation={evaluation} /> },
        { key: "statistics", label: "Statistics", icon: "fas fa-chart-pie", content: <EvaluationStats log={evaluation.log} onResetDemo={evaluation.resetDemoData} /> },
    ];

    return (
        <PageTable>
            <Header title={<span>{"Call Evaluation"}</span>}></Header>
            <div className="ce">
                <Tabs tabs={tabs} />
            </div>
        </PageTable>
    );
}

export default CallEvaluationPage;
